<template>
  <v-container>
    <base-material-card color="primary" inline icon="mdi-account" class="px-5 py-3">
      <form>
        <v-row class="mx-auto" justify="space-around" style="max-width: 500px">
          <v-col cols="auto" class="text-center">
            <input ref="file" type="file" class="d-none" @change="onChangePicture" />
            <v-card
              :class="image ? 'primary--text' : 'grey--text'"
              class="d-inline-flex mt-0 mx-auto v-card--account"
              outlined
              height="106"
              width="106"
              @click="$refs.file.click()"
            >
              <v-img v-if="image" :src="image" height="100%" width="100%" />
              <v-icon v-else class="mx-auto" size="96">mdi-account</v-icon>
            </v-card>

            <div class="font-weight-bold grey--text">ESCOLHA UMA IMAGEM</div>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="nome" color="primary" label="Primeiro Nome*" />

            <v-text-field v-model="sobrenome" color="primary" label="Sobrenome*" />
          </v-col>

          <v-col cols="12">
            <v-text-field v-model="user.email" color="primary" label="Email" prepend-icon="mdi-email" disabled />

            <v-text-field
              v-model="senha"
              color="primary"
              :type="iconEye ? 'text' : 'password'"
              label="Senha"
              prepend-icon="mdi-key"
              :append-icon="iconEye ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="iconEye = !iconEye"
            />

            <v-text-field
              v-model="senha2"
              color="primary"
              :type="iconEye ? 'text' : 'password'"
              label="Confirmar Senha"
              prepend-icon="mdi-key"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6"></v-col>
          <v-col cols="12" md="6">
            <v-btn color="green" min-width="100" style="float: right" class="mt-n5" @click="postUsuarioFirebase">Salvar</v-btn>
          </v-col>
        </v-row>
      </form>
    </base-material-card>
  </v-container>
</template>

<script>
  import Firestore from '@/Firestore.js';
  import Firestorage from '@/Firestorage.js';
  import * as firebase from 'firebase/app';
  import FirebasePt from '@/config/FirebaseTraducaoPt.js';

  export default {
    data() {
      return {
        iconEye: false,
        image: null,
        imageFile: null,
        senha: '',
        senha2: '',
        nome: '',
        sobrenome: ''
      };
    },

    computed: {
      userIsAdmin() {
        return this.$store.getters.userIsAdmin;
      },
      user() {
        return this.$store.getters.getUser;
      }
    },
    mounted() {
      if (this.user) {
        this.getUsuarioLogado();
      }
    },

    methods: {
      onChangePicture(val) {
        this.imageFile = val.target.files[0];

        if (!this.imageFile) return (this.image = null);

        this.image = URL.createObjectURL(this.imageFile);
      },

      getUsuarioLogado() {
        this.nome = ' ';
        Firestore.collection('usuarios')
          .doc(this.user.uid)
          .get()
          .then((doc) => {
            this.nome = doc.data().nome;
            this.sobrenome = doc.data().sobrenome;
            this.getUsuarioProfilePic();
          })
          .catch((error) => {
            console.error('Error: ', error);
          });
      },
      postUsuarioFirebase() {
        if (!this.nome.trim()) {
          this.$toast.warning('O campo primeiro nome é obrigatorio.', '', { position: 'topRight' });
          return;
        } else if (!this.sobrenome.trim()) {
          this.$toast.warning('O campo sobrenome é obrigatorio.', '', { position: 'topRight' });
          return;
        }

        if (this.imageFile) {
          let extensoesAceitas = ['jpg', 'jpeg', 'png', 'bpm', 'gif'];
          let extensionImage = this.imageFile.name;
          extensionImage = extensionImage.substr(
            extensionImage.indexOf('.') + 1,
            extensionImage.length
          ); /* Recorta a extensão do arquivo */

          if (extensoesAceitas.indexOf(extensionImage) == -1) {
            this.$toast.error(
              'Extensão de arquivo não permitida, apenas imagens .jpg, .jpeg, .png, .bpm, .gif são aceitas.',
              '',
              { position: 'topRight' }
            );
            return;
          } else if (this.imageFile.size > 1048576) {
            /* 1048576(BYTES) == 1(MB) */
            this.$toast.error('Apenas imagens de até 1MB são permitidas', '', { position: 'topRight' });
            return;
          }
        }

        if (this.senha) {
          if (this.senha != this.senha2) {
            this.$toast.error('As senhas inseridas não são iguais.', '', { position: 'topRight' });
            return;
          }

          var user = firebase.auth().currentUser;
          user
            .updatePassword(this.senha)
            .then(() => {
              this.$toast.success('Senha alterada.', '', { position: 'topRight' });
            })
            .catch((error) => {
              console.log(error);
              let errorMessage = FirebasePt[error.code] ? FirebasePt[error.code] : error.message;
              this.$toast.error('Falha ao alterar senha:<br>' + errorMessage, '', { position: 'topRight' });
            });
        }

        Firestore.collection('usuarios')
          .doc(this.user.uid)
          .set({
            nome: this.nome,
            sobrenome: this.sobrenome,
            email: this.user.email,
            admin: this.userIsAdmin
          })
          .then(async () => {
            this.$toast.success('Informações atualizadas.', '', { position: 'topRight' });
            this.uploadProfilePic();
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error('Erro ao atualizar perfil.', '', { position: 'topRight' });
          });
      },

      getUsuarioProfilePic() {
        var pathReference = Firestorage.ref('usuarios/profile_pictures/' + this.user.uid + '.jpeg');

        pathReference
          .getDownloadURL()
          .then((url) => {
            this.image = url;
          })
          .catch((error) => {
            console.log(error);
            //this.$toast.error('Erro ao atualizar foto de perfil.', '',{position:'topRight'})
          });
      },

      uploadProfilePic() {
        if (!this.imageFile) return;

        var storageRef = Firestorage.ref('usuarios/profile_pictures/' + this.user.uid + '.jpeg');

        let uploadTask = storageRef.put(this.imageFile);

        uploadTask.on(
          'state_changed',
          () => {},
          (error) => {
            console.log(error);
            this.$toast.error(error.message, 'Erro durante upload de foto de perfil', { position: 'topRight' });
          },
          () => {
            // Handle primaryful uploads on complete
            // For instance, get the download URL: https://firebasestorage.googleapis.com/...
            uploadTask.snapshot.ref.getDownloadURL().then(() => {
              this.$toast.success('Foto de perfil atualizada.', '', { position: 'topRight' });
            });
          }
        );
      }
    },

    watch: {
      '$store.state.user': {
        deep: true,
        handler() {
          if (!this.nome) {
            this.getUsuarioLogado();
          }
        }
      }
    }
  };
</script>
